"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUserBasketsQuery = exports.basketsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var base_query_1 = require("./base_query");
var basketsApi = (0, react_1.createApi)({
    reducerPath: "basketsApi",
    baseQuery: (0, base_query_1.authorisedBaseQuery)((_a = process.env.LETS_TRADE_BASKET_URL) !== null && _a !== void 0 ? _a : ""),
    refetchOnMountOrArgChange: 30,
    refetchOnFocus: true,
    tagTypes: ["Basket"],
    endpoints: function (builder) { return ({
        getUserBaskets: builder.query({
            query: function (args) { return ({ url: "v2/user/basket/list", params: args }); },
            transformResponse: function (response) { var _a; return (_a = (0, base_query_1.unwrapEnvelope)(response)) !== null && _a !== void 0 ? _a : { baskets: [], count: 0 }; },
            providesTags: function (_result, _error, args) { return [{ type: "Basket", id: args.user_id }]; },
        }),
    }); },
});
exports.basketsApi = basketsApi;
var useGetUserBasketsQuery = basketsApi.useGetUserBasketsQuery;
exports.useGetUserBasketsQuery = useGetUserBasketsQuery;
